export const getLevel = () => {
  const envMap = {
    development: "log",
    test: "log",
    uat: "log",
    production: "warn"
  }
  return envMap[process.env.NODE_ENV]
}

export function CreateLogger(options = {}) {
  const logLevel = options.level || "info"
  // 定义日志级别的优先顺序
  const levels = ["error", "warn", "info", "debug", "log"]

  const Logger = {}
  // 创建各个日志级别的方法
  levels.forEach(level => {
    if (levels.indexOf(level) <= levels.indexOf(logLevel)) {
      Logger[level] = (message, error = "") => {
        console[level](`[${level.toUpperCase()}] ${message}`, error)
      }
    } else {
      Logger[level] = () => {}
    }
  })
  return Logger
}

export const Logger = CreateLogger({ level: getLevel() })

export default function ({ app }, inject) {
  inject("Logger", Logger)
}
